import React from 'react';

const SignupVisualSection = ({ mounted, currentStep }) => {
  return (
    <div className="lg:flex-1 relative bg-gradient-to-br from-green-500 via-green-600 to-emerald-700 order-2 lg:order-1">
      <div className="absolute inset-0 bg-black bg-opacity-10"></div>
      
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-40 h-40 bg-white bg-opacity-10 rounded-full animate-float-slow"></div>
        <div className="absolute top-1/3 right-1/4 w-32 h-32 bg-white bg-opacity-10 rounded-full animate-float-medium"></div>
        <div className="absolute bottom-1/4 left-1/3 w-36 h-36 bg-white bg-opacity-15 rounded-full animate-float-slower"></div>
      </div>

      <div className="relative h-full flex items-center justify-center p-6 lg:p-12">
        <div className={`text-center text-white max-w-md transform transition-all duration-1000 ease-out ${
          mounted ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <div className="w-16 h-16 bg-white bg-opacity-20 rounded-2xl flex items-center justify-center mx-auto mb-6 backdrop-blur-md shadow-lg animate-glow">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          
          <h2 className="text-2xl lg:text-3xl xl:text-4xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-white to-emerald-100 leading-tight">
            Join Our Educator Community
          </h2>
          
          <p className="text-sm lg:text-base text-emerald-100 mb-6 leading-relaxed font-light">
            Start creating impactful learning experiences with Pengravity LMS.
          </p>

          {/* Step Indicator */}
          <div className="flex justify-center space-x-2 mb-8">
            {[1, 2, 3].map((step) => (
              <div
                key={step}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  step === currentStep
                    ? 'bg-white scale-125'
                    : step < currentStep
                    ? 'bg-green-300'
                    : 'bg-white bg-opacity-30'
                }`}
              />
            ))}
          </div>

          <div className="text-left space-y-4">
            <div className={`transition-all duration-500 ${
              currentStep >= 1 ? 'opacity-100' : 'opacity-50'
            }`}>
              <h3 className="text-lg font-semibold mb-2">Step 1: Personal Info</h3>
              <p className="text-emerald-100 text-sm">Tell us about yourself and your background</p>
            </div>
            
            <div className={`transition-all duration-500 delay-200 ${
              currentStep >= 2 ? 'opacity-100' : 'opacity-50'
            }`}>
              <h3 className="text-lg font-semibold mb-2">Step 2: Professional Info</h3>
              <p className="text-emerald-100 text-sm">Share your expertise and experience</p>
            </div>
            
            <div className={`transition-all duration-500 delay-400 ${
              currentStep >= 3 ? 'opacity-100' : 'opacity-50'
            }`}>
              <h3 className="text-lg font-semibold mb-2">Step 3: Secure Account</h3>
              <p className="text-emerald-100 text-sm">Create password and agree to terms</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupVisualSection;